import styled from "styled-components";
import { TailSpin } from "react-loader-spinner";

function LoadingIcon({}) {
    return (
        <LoadingContainerStyled>
            <TailSpin
                visible={true}
                height = "40"
                width = "40"
                color = "#006580"
                ariaLabel = "tail-spin-loading"
                radius= "1"            
            >
            </TailSpin>
        </LoadingContainerStyled>
    )
}

const LoadingContainerStyled = styled.div`
    position: fixed;
    inset: 0;
    top: 120px;
    background-color: white;
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    z-index:10;
`

export default LoadingIcon
